import { ContentUtils } from 'braft-utils';
export const siteName = '知图平台'; 
export const imgUrlSite = 'https://zhitu.sozdata.com/';
export const requestMainUrl = 'https://zhitu.sozdata.com/';
// export const requestMainUrl = 'http://192.168.1.129:9527/';
export const requestWebSocketUrl = 'wss://zhitu.sozdata.com';//'wss://applets.sozdata.com';//
export const requestWeChatUrl = 'http://public.sozdata.com/';//微信公众号地址
export const xiaochengxuSite='https://applets.sozdata.com/';
// export const imgUrlSite = 'http://121.52.216.138/';

export const baseUrl = {
    personalHead: requestMainUrl, 
    shareUrl: requestMainUrl, //分享复制链接地址
    WebSockeUrl: requestWebSocketUrl, //WebSocket地址：192.168.1.131:9520
}
export const filterUniversityName = ['大学','学院','学校'];
export const urlPrefix = {
    0:'',
    1:'ja/',
    2:'sc/',
    3:'con/',
    4:'main/',
    5:'search/',
    6:'exam/',
    // 7:'msg/',//系统通知模块消息列表（没用到）
}


// 
/**
 * 手机号码正则验证
 * @param value
 */
export function isPhone(value) {
    var reg = /^1[0-9]{10}$/;
    if (!reg.test(value)) {
        return false;
    } else {
        return true;
    }
}

/**
 * 邮箱正则验证
 * @param value
 */
export function isEmail(value) {
    var reg = /^[0-9a-zA-Z_.-]+[@][0-9a-zA-Z_.-]+([.][a-zA-Z]+){1,2}$/;
    if (!reg.test(value)) {
        return false;
    } else {
        return true;
    }
}
/**
 * 昵称正则验证
 * @param value
 * 支持中英文、数字、“_”或减号
 */
export function isName(value) {
    var myregex =/^[0-9A-Za-z\u4e00-\u9fa5_-]+$/;
    if (!myregex.test(value)){
        return false;
    }else{
        return true;
    }
}



/* /^[\u4E00-\u9FA5]$/; */
/**
 * 数字类型正则验证
 * @param value
 */
export function checkRate(value) {
    var reg = /^[0-9]+.?[0-9]*/; //判断字符串是否为数字//判断正整数/[1−9]+[0−9]∗]∗/ 
    if (!reg.test(value)) {
       return false;
    } else {
        return true;
    }
}
/**
 * 过滤输入框里的间括号
 * @param html
 */
export function HTMLEncode(html){
    var temp = document.createElement("div");
    (temp.textContent != null) ? (temp.textContent = html) : (temp.innerText = html);
    var output = temp.innerHTML;
    temp = null;
    return output;
}

/**
 * 限制字数,超出部分以省略号显示...
 * @param date //数据
 * @param number //限制字数
 */
export function fontNumbers(date, number) {
    const length = date.length;
    if (length > number) {
        var str = ''
        str = date.substring(0, number) + '……';
        return str;
    } else {
        return date+'……';
    }
}

// html5本地储存 localStorage
export function setLocalItem(key, value) {
    if (typeof (value) != 'string') {
        value = JSON.stringify(value);
    }
    return window.localStorage.setItem(key, value);
}
export function getLocalItem(key) {
    var string = window.localStorage.getItem(key);
    try {
        var obj = JSON.parse(string);
        if (typeof obj === 'object' && obj) {
            return obj;
        } else {
            if (string === 'null') {
                return null;
            } else {
                return string;
            }
        }
    } catch (e) {
        if (string === 'null') {
            return null;
        } else {
            return string;
        }
    }
}
export function delLocalItem(key) {
    localStorage.removeItem(key);
}

// html5本地储存封装sessionStorage
export function setSessionItem(key, value) {
    if (typeof (value) !== 'string') {
        value = JSON.stringify(value);
    }
    return window.sessionStorage.setItem(key, value);
}
export function getSessionItem(key) {
    var string = window.sessionStorage.getItem(key);
    try {
        var obj = JSON.parse(string);
        if (typeof obj === 'object' && obj) {
            return obj;
        } else {
            if (string === 'null') {
                return null;
            } else {
                return string;
            }
        }
    } catch (e) {
        if (string === 'null') {
            return null;
        } else {
            return string;
        }
    }
}
export function delSessionItem(name) {
    window.sessionStorage.removeItem(name);
}

export const thousandSplit = function (num) {
    return ("" + num).replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, "$1,")
}

export function getCookie(sname){
    var acookie = document.cookie.split("; ");
    for (var i = 0; i < acookie.length; i++) {
        var arr = acookie[i].split("=");
        if (sname === arr[0]) {
            if (arr.length > 1)
                return unescape(arr[1]);
            else
                return "";
        }
    }
    return "";
}

export function setCookie(name,value,option){
    var seconds = option.time*24*60*60 || 0;
    var expires = "";
    if (seconds !== 0 ) {      //设置cookie生存时间
        var date = new Date();
        date.setTime(date.getTime()+(seconds*1000));
        expires = "; expires="+date.toGMTString();
    }
    var path = option.path||'/';
    document.cookie = name+"="+escape(value)+expires+"; path="+path;
}

export function delCookie(name) {
    setCookie(name,'',{time:-1});
}






// 下载
export function downloadFile (url) {
    return url+'&sid='+getCookie('z_sid')
}







/*
 * 时间日期格式化
 * 超过3天显示具体时间(xxxx-xx-xx)
 * 未超过3天显示（刚刚、x小时前、x天前）
 * @param time
 */
export function getAateList(time) {
    let oldDate = new Date(time)
    let newDate = new Date()
    var dayNum = "";
    var getTime = (newDate.getTime() - oldDate.getTime()) / 1000;
    let year = oldDate.getFullYear();
    let month = oldDate.getMonth() + 1;
    let day = oldDate.getDate();
    if (getTime < 60 * 5) {
        dayNum = "刚刚";
    } else if (getTime >= 60 * 5 && getTime < 60 * 60) {
        dayNum = parseInt(getTime / 60) + "分钟前";
    } else if (getTime >= 3600 && getTime < 3600 * 24) {
        dayNum = parseInt(getTime / 3600) + "小时前";
    } else if (getTime >= 3600 * 24 && getTime < 3600 * 24 * 7) {
        dayNum = parseInt(getTime / 3600 / 24) + "天前";
    }
    // else if(getTime >= 3600 * 24 * 30 && getTime < 3600 * 24 * 30 * 12){
    // 	dayNum = parseInt(getTime / 3600 / 24 / 30 ) + "个月前";  
    // }
    // else if(time >= 3600 * 24 * 30 * 12){
    // 	dayNum = parseInt(getTime / 3600 / 24 / 30 / 12 ) + "年前";  
    // }
    else {
        dayNum = year + "-" + month + "-" + day;
    }
    return dayNum;
}
/*
 * 时间日期格式化(xxxx-xx-xx xx:xx:xx)
 * @param time
 */
export function getDateAll(date,format) {
    var oldDate;
    if(!date)return "";
    if(typeof date === 'string'){
        oldDate = new Date(date.replace(/-/g,'/').replace(/T|Z/g,' ').trim());
    }else if(typeof date === 'object'){
        oldDate = new Date(date) ;
    }
    // let oldDate = new Date(date)
    let year = oldDate.getFullYear();
    let month = oldDate.getMonth() + 1;
    let day = oldDate.getDate();
    let hour = oldDate.getHours();
    let minute = oldDate.getMinutes();
    let second = oldDate.getSeconds();
    if (oldDate.getMonth() + 1 < 10) {
        month = '0' + month
    }
    if (oldDate.getDate() < 10) {
        day = '0' + day
    }
    if (oldDate.getHours() < 10) {
        hour = '0' + hour
    }
    if (oldDate.getMinutes() < 10) {
        minute = '0' + minute
    }
    if (oldDate.getSeconds() < 10) {
        second = '0' + second
    }
    return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
}
/*
 * 时间日期格式化(xxxx-xx-xx)
 * @param time
 */
export function getDateTime(time) {
    let oldDate = new Date(time)
    let year = oldDate.getFullYear();
    let month = oldDate.getMonth() + 1;
    let day = oldDate.getDate();
    if (oldDate.getMonth() + 1 < 10) {
        month = '0' + month
    }
    if (oldDate.getDate() < 10) {
        day = '0' + day
    }
    return year + "-" + month + "-" + day;
}


export const classifyCode = {
    org: '01', //机构
    user: '02', //用户
    academicJournal: '03', //学术期刊
    journalThesis: '04', //期刊论文
    editorInterpretation: '05', //主编解读
    editorInterpretationComment: '0501', //主编解读评论
    foreignInterpretation: '06', //外文阐释
    foreignInterpretationComment: '0601', //外文阐释评论
    specialColumnArticle: '07', //专栏文章
    specialColumnArticleCommnet: '0701', //专栏文章评论
    dynamic: '08', //动态
    dynamicComment: '0801', //动态评论
    question: '09', //问题
    answer: '10', //回答
    answerComment: '1001', //回答评论
}

export function urlGet(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) {
        return decodeURI(r[2]);
    } else {
        return null;
    }
}

export function setImgUrl(url) {
    if(url.indexOf('http')!==-1) {
        return url;
    } else {
        return imgUrlSite+url;
    }
}

export function isLowerIE() {
    var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串  
    var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器  
    var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器  
    var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
    if(isIE) {
        var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
        reIE.test(userAgent);
        var fIEVersion = parseFloat(RegExp["$1"]);
        if(fIEVersion === 7) {
            return 7;
        } else if(fIEVersion === 8) {
            return 8;
        } else if(fIEVersion === 9) {
            return 9;
        } else if(fIEVersion === 10) {
            return 10;
        } else {
            return 6;//IE版本<=7
        }   
    } else if(isEdge) {
        return 'edge';//edge
    } else if(isIE11) {
        return 11; //IE11  
    }else{
        return null;//不是ie浏览器
    }
}

// 在meta上添加参数
export const getDocumentMeta=(topicNamestr)=>{
    return document.querySelector('meta[name="keywords"]').setAttribute('content',topicNamestr);;
}




export const getControlsBar=(editStage,setEdiStage,other)=>{
    let defaultControls = [
        'h1','h2','unstyled','separator',
        'bold', 'separator',
        'list-ul', 'list-ol', 'blockquote', 'separator',
        'text-align', 'separator',
        'link', 'separator', 'hr','separator', 
        'remove-styles'
    ];
    if(other) {
        defaultControls.push(other.name);
    }
    if(!isLowerIE()||isLowerIE()>9) {
        defaultControls.splice(14, 0, "media");
    }
    let controls = defaultControls.map(item => {
        var result;
        switch(item) {
            case 'media':
                result = {
                    key:'media',
                    title:'图片'
                }
                break;
            case 'h1':
                result = {
                    type:'button',
                    key:'h1',
                    text:'一级标题',
                    className:(()=>{                            
                        var blockType = ContentUtils.getSelectionBlockType(editStage);
                        if(blockType==='header-one') {
                            return 'active';
                        } else {
                            return '';
                        }
                    })(),
                    onClick:()=>{
                        setEdiStage(ContentUtils.toggleSelectionBlockType(editStage,'header-one'));                      
                    }
                }
                break;
            case 'h2':
                result = {
                    type:'button',
                    key:'h2',
                    text:'二级标题',
                    className:(()=>{                            
                        var blockType = ContentUtils.getSelectionBlockType(editStage);
                        if(blockType==='header-two') {
                            return 'active';
                        } else {
                            return '';
                        }
                    })(),
                    onClick:(e)=>{
                        setEdiStage(ContentUtils.toggleSelectionBlockType(editStage,'header-two'));
                    }
                }
                break;
            case 'unstyled':
                result = {
                    type:'button',
                    key:'unstyled',
                    text:'正文',
                    className:(()=>{                            
                        var blockType = ContentUtils.getSelectionBlockType(editStage);
                        if(blockType==='unstyled') {
                            return 'active';
                        } else {
                            return '';
                        }
                    })(),
                    onClick:(e)=>{
                        setEdiStage(ContentUtils.toggleSelectionBlockType(editStage,'unstyled'));
                    }
                }
                break;
            default:
                result = item;
                break;
        }
        return result;
    });
    if(other) {
        controls.push({
            type:'button',
            key:other.name,
            text:other.title
        })
    }
    return controls;
}

export const htmlToText = (htmlStr)=>{
    return htmlStr.replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi,'').replace(/<[^>]+?>/g,'').replace(/\s+/g,' ').replace(/ /g,' ').replace(/>/g,' ');
} 


